import { DollarSign } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SERVICE_AREAS } from "../../constants/brands";

export const LocalPickup = ({ onOpenForm }) => (
  <section className="py-16 md:py-20 bg-[#0F5132]" data-testid="local-pickup-section">
    <div className="container-custom">
      <div className="max-w-4xl mx-auto text-center text-white">
        <div className="inline-flex items-center gap-2 bg-white/20 px-4 py-2 rounded-full text-sm font-semibold mb-6">
          <DollarSign className="w-4 h-4" />
          Same Day Cash
        </div>
        <h2 className="text-3xl md:text-4xl font-bold mb-6" style={{ fontFamily: "Manrope" }}>
          Local? Get Paid Today!
        </h2>
        <p className="text-lg md:text-xl text-white/90 mb-8 leading-relaxed">
          If you're in the Jacksonville, FL area, we'll meet up and pay you <span className="font-bold text-white">same day cash</span>!
        </p>
        <div className="flex flex-wrap justify-center gap-3 text-sm">
          {SERVICE_AREAS.map((location) => (
            <span key={location} className="bg-white/20 px-4 py-2 rounded-full">
              {location}
            </span>
          ))}
        </div>
        <Button
          onClick={onOpenForm}
          className="mt-10 bg-[#EA580C] hover:bg-[#C2410C] text-white rounded-full px-8 py-6 text-lg font-semibold shadow-lg"
          data-testid="local-sell-btn"
        >
          Get Same Day Cash
        </Button>
      </div>
    </div>
  </section>
);
